<script lang="ts">
  // A small colour marker for clients, series and legends.
  //   <ColorDot color={clientColor(client)} />            rounded square (default)
  //   <ColorDot color="var(--chart-2)" shape="round" />   circle (legends)
  //   <ColorDot color="var(--success)" pulse />           live indicator
  // Decorative by default; pass `label` to announce it.
  interface Props {
    color: string | null | undefined;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    shape?: 'square' | 'round';
    /** Soft halo around the dot (selected state, live dots). */
    ring?: boolean;
    /** Gentle blinking, e.g. for a running timer. */
    pulse?: boolean;
    label?: string;
    class?: string;
  }
  let { color, size = 'sm', shape = 'square', ring = false, pulse = false, label, class: cls = '' }: Props = $props();
</script>

<span
  class="dot {size} {shape} {cls}"
  class:ring
  class:pulse
  style:--c={color || 'var(--text-3)'}
  role={label ? 'img' : undefined}
  aria-label={label}
  aria-hidden={label ? undefined : 'true'}
></span>

<style>
  .dot {
    --s: 8px;
    display: inline-block;
    flex-shrink: 0;
    width: var(--s);
    height: var(--s);
    background: var(--c);
    border-radius: var(--radius-2xs);
  }
  .xs { --s: 6px; }
  .sm { --s: 8px; }
  .md { --s: 10px; }
  .lg { --s: 12px; }
  .xs.square { border-radius: var(--radius-2xs); }
  .round { border-radius: var(--radius-full); }
  .ring { box-shadow: 0 0 0 3px color-mix(in srgb, var(--c) 22%, transparent); }
  .pulse { animation: pulse-dot 1.6s ease-in-out infinite; }
  @media (prefers-reduced-motion: reduce) {
    .pulse { animation: none; }
  }
</style>
